import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { TypeDocument } from 'src/app/shared/models/typeDocument';

@Injectable({
	providedIn: 'root'
})
export class TypeDocumentService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeDocument(): Observable<TypeDocument[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeDocumentUrl}/all`,
			'getAllTypeDocument'
		);
	}

	importTypeDocument(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeDocument.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeDocumentUrl}/import`,
			`importTypeDocument`,
			formData
		);
	}

	getTypeDocumentById(id: number): Observable<TypeDocument> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeDocumentUrl}/get/${id}`,
			'getTypeDocumentById'
		);
	}

	updateTypeDocument(typeDocument: TypeDocument): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeDocumentUrl}/update/${typeDocument.id}`,
			'updateTypeDocument',
			typeDocument
		);
	}

	addTypeDocument(typeDocument: TypeDocument): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeDocumentUrl}/add`,
			'addTypeDocument',
			typeDocument
		);
	}

	deleteTypeDocument(typeDocumentId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeDocumentUrl}/delete/${typeDocumentId}`,
			`deleteTypeDocument`
		);
	}
}
